<div class="container-fluid py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Organizations</h2>
      <div>
        <button type="button" class="btn btn-primary me-2" [routerLink]="['/organization/create']">
          <i class="bi bi-plus-lg me-2"></i> Add New Organization
        </button>
      </div>
    </div>
  
    <div class="d-flex justify-content-between mb-3">
      <input type="text" class="form-control me-2" placeholder="Search Organizations..."
             [(ngModel)]="searchQuery" (input)="filterOrganizations()" />
      <button class="btn btn-outline-secondary" (click)="clearSearch()">Clear</button>
    </div>
  
  
    <div class="card shadow-sm">
      <div class="card-header bg-primary text-white">
        <h5 class="mb-0">Organization List</h5>
      </div>
      <div class="card-body p-0">
        <ag-grid-angular class="ag-theme-alpine" style="height: 600px; width: 100%;"
                         [gridOptions]="gridOptions" [loading]="true" (gridReady)="onGridReady($event)" 
                         [rowData]="filteredOrganizations" [rowSelection]="rowSelection" [modules]="modules">
        </ag-grid-angular>
      </div>
    </div>
  </div>
  
  <!-- Delete Modal -->
  <ng-template #deleteConfirmModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title text-danger"><i class="bi bi-exclamation-triangle"></i> Confirm Deletion</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <p>Are you sure you want to delete this Organization?</p>
      <p class="text-muted small">This action cannot be undone.</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn btn-danger" (click)="confirmDeleteItem(modal)">Delete</button>
    </div>
  </ng-template>